interface UptimeBarProps {
  uptime7d: number | null;
  uptime30d: number | null;
  uptime90d: number | null;
}

interface UptimePeriod {
  label: string;
  value: number | null;
}

function getBarColor(pct: number): string {
  if (pct >= 99.9) return "bg-emerald-500";
  if (pct >= 99.0) return "bg-emerald-400";
  if (pct >= 95.0) return "bg-amber-400";
  if (pct >= 90.0) return "bg-orange-400";
  return "bg-red-400";
}

function formatUptime(value: number | null): string {
  if (value === null) return "--";
  return `${value.toFixed(2)}%`;
}

export default function UptimeBar({ uptime7d, uptime30d, uptime90d }: UptimeBarProps) {
  const periods: UptimePeriod[] = [
    { label: "7d", value: uptime7d },
    { label: "30d", value: uptime30d },
    { label: "90d", value: uptime90d },
  ];

  const hasAnyData = periods.some((p) => p.value !== null);

  if (!hasAnyData) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      {periods.map((period) => (
        <div key={period.label} className="flex items-center gap-2">
          <span className="w-6 text-right text-xs text-gray-400">
            {period.label}
          </span>
          <div className="h-2 w-16 overflow-hidden rounded-full bg-gray-100 sm:w-24">
            {period.value !== null ? (
              <div
                className={`h-full rounded-full transition-all ${getBarColor(period.value)}`}
                style={{ width: `${Math.min(period.value, 100)}%` }}
                role="meter"
                aria-label={`${period.label} uptime: ${formatUptime(period.value)}`}
                aria-valuenow={period.value}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            ) : (
              <div className="h-full w-0" />
            )}
          </div>
          <span className="w-14 text-xs tabular-nums text-gray-600">
            {formatUptime(period.value)}
          </span>
        </div>
      ))}
    </div>
  );
}
